"use client"

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"
import { useRouter } from "next/navigation"
import { ReactNode } from "react"
import { VisuallyHidden } from "react-aria"

export default function Layout({ children }: { children: ReactNode }) {
  const router = useRouter()

  return (
    <Dialog defaultOpen open onOpenChange={() => router.back()}>
      <DialogContent
        forceMount
        className="sm:max-w-[640px] px-6 pt-6 sm:max-h-[90vh] overflow-y-auto overflow-x-hidden sm:h-auto max-h-[90vh] w-screen flex flex-col sm:grid"
      >
        {/** This will be overridden by the page.tsx that has it's own header. */}
        <VisuallyHidden>
          <DialogTitle>Collectors</DialogTitle>
        </VisuallyHidden>
        {children}
      </DialogContent>
    </Dialog>
  )
}
